export default __webpack_public_path__ + "static/media/external-link.f1a5da70.svg";